import { CreateSuperAdminActionTypes, CreateForgotPasswordActionTypes, getIMCclientDetailsActionTypes } from '../actionsTypes';

export const createSuperAdminRequest = (params) => {
    return {
        type: CreateSuperAdminActionTypes.REQUEST,
        payload: params,
    };
};

export const createForgotPasswordRequest = (params) => {
    return {
        type: CreateForgotPasswordActionTypes.REQUEST,
        payload: params,
    };
};

export const getIMCclientDetails = (params) => {
    return {
        type: getIMCclientDetailsActionTypes.REQUEST,
        payload: params,
    };
};

export const resetCreateSuperAdminError = (params) => {
    return {
        type: CreateSuperAdminActionTypes.RESET_ERROR,
        payload: params,
    };
};

export const resetForgotPasswordError = (params) => {
    return {
        type: CreateForgotPasswordActionTypes.RESET_ERROR,
        payload: params,
    };
};




